<!-- 财务中心 -->
<template>
    <div style="margin-top: 20px;">
        <!-- 左边导航 -->
        <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
            <div class="mouse selected">财务流水</div>
        </div>
        <div style="float: right;display: flex;">
            <el-button v-no-more-click size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
            <!-- <el-button v-if="addFinanceAuth" size="small" icon="el-icon-plus" class="clue-btn" @click="handleAddFinance">新增流水</el-button> -->
            <!-- <el-button v-if="importFinanceAuth" size="small" icon="el-icon-top" class="clue-btn" @click="handleExportFinance">流水导入</el-button> -->
            <!-- <el-button v-if="addFinanceAuth" size="small" icon="el-icon-delete" class="clue-btn" @click="checkDelFinance">删除</el-button> -->
        </div>
        <!-- 业绩统计 -->
        <!-- <div class="fee-content">
          <div class="fee-item"><span class="fee-title">余额</span><span class="fee-v">{{ totalFee }}</span></div>
        </div> -->
        <!--列表-->
        <el-table size="small" :data="customerData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
            <!-- <el-table-column align="center" type="selection" width="40">
            </el-table-column>   -->
            <!-- <el-table-column prop="event_time" align="center" label="时间" show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="color: #407AA8;cursor: pointer;" title="编辑流水" @click="handleAddFinance(scope.$index, scope.row)">{{ scope.row.event_time }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="color: #407AA8;cursor: pointer;" title="查看流水详情" @click="getFinanceList(scope.$index, scope.row)">{{ scope.row.customer_name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="admin_name" align="center" label="当前跟进人" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column prop="apply_number" align="center" label="项目编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="apply_item" align="center" label="项目名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="income" align="center" label="收入金额" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="expense" align="center" label="支出金额" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="payer" align="center" label="付款单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="payee" align="center" label="收款单位" show-overflow-tooltip>
            </el-table-column> -->
            <el-table-column prop="balance" align="center" label="余额" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column prop="desc" align="center" label="备注" show-overflow-tooltip>
            </el-table-column> -->
        </el-table>

        <!-- 流水导入 -->
        <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="exportFormVisible" width="50%" @click="closeDialog('importForm')">
            <el-form label-width="120px">
              <el-row>
                <el-form-item label="客户名称" prop="customer_id">
                  <el-select size="small" v-model="importFinanceForm.customer_id" placeholder="请选择客户" filterable clearable style="width: 360px;" @change="handleImportCustomerChange()">
                    <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                  <el-form-item label="上传Excel" prop="content">
                      <el-upload
                      class="upload-demo"
                      drag
                      :action=uploadExcel
                      :headers=setHeader
                      :data=importFinanceForm
                      :before-upload="beforeAvatarVideoUpload"
                      :before-remove="beforeRemove"
                      :on-remove="handleRemove"
                      :on-success="handleSuccess"
                      list-type="none"
                      >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip" slot="tip">只能上传xlsx或xls文件，且不超过10M
                          <!-- <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="下载客户导入excel模板" @click="downloadImportExcel()">下载客户模板</span> -->
                          <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="查看导入模板" @click="viewFinanceMB()">查看模板</span>
                      </div>
                      </el-upload>
                      </el-form-item>
              </el-row>
            </el-form>
        </el-dialog>

        <!-- 新增流水 -->
        <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="addFormVisible" width="850px">
          <el-form label-width="120px" :model="addFinanceForm" :rules="addFinanceFormRule" ref="addFinanceForm">
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称" prop="customer_id">
                  <el-select size="small" v-model="addFinanceForm.customer_id" placeholder="请选择客户" filterable clearable style="width: 285px;" @change="handleCustomerChange()">
                    <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="项目编号" prop="apply_number">
                  <el-input size="small" v-model.trim="addFinanceForm.apply_number" auto-complete="off" placeholder="项目编号(专利号、软著号等)" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目名称" prop="apply_item">
                  <el-input size="small" v-model.trim="addFinanceForm.apply_item" auto-complete="off" placeholder="项目名称(专利名称、软件名称等)" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目时间" prop="event_time">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.event_time" auto-complete="off" placeholder="格式:2025.09.04" clearable></el-input> -->
                  <el-date-picker
                    v-model="addFinanceForm.event_time"
                    type="date"
                    value-format="yyyy.MM.dd"
                    placeholder="选择项目日期"
                    align="right"
                    :picker-options="pickerOptions" style="width: 285px;">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="项目备注" prop="desc">
                  <el-input size="small" v-model.trim="addFinanceForm.desc" auto-complete="off" placeholder="备注" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收入金额" prop="income">
                  <el-input size="small" v-model.trim="addFinanceForm.income" auto-complete="off" placeholder="收入金额" @change="moneyChange()" clearable></el-input>
                </el-form-item>
                <el-form-item label="支出金额" prop="expense">
                  <el-input size="small" v-model.trim="addFinanceForm.expense" auto-complete="off" placeholder="支出金额" @change="moneyChange()" clearable></el-input>
                </el-form-item>
                <el-form-item label="付款单位" prop="payer">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.payer" auto-complete="off" placeholder="付款单位" clearable></el-input> -->
                   <el-select v-model="addFinanceForm.payer" placeholder="请选择或填写" filterable allow-create clearable style="width: 285px;">
                      <el-option v-for="item in companys" :key="item.value" :label="item.key" :value="item.value"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="收款单位" prop="payee">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.payee" auto-complete="off" placeholder="收款单位" clearable></el-input> -->
                  <el-select v-model="addFinanceForm.payee" placeholder="请选择或填写" filterable allow-create clearable style="width: 285px;">
                      <el-option v-for="item in companys" :key="item.value" :label="item.key" :value="item.value"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="账户余额" prop="balance">
                  <el-input size="small" v-model.trim="addFinanceForm.balance" auto-complete="off" placeholder="账户余额" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button v-no-more-click size="mini" type="primary" @click="addFinance('addFinanceForm')">提交</el-button>
              <el-button size="mini" @click='closeAddFinanceDialog()'>取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        
        <!-- 修改流水 -->
        <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="editFormVisible" width="850px">
          <el-form label-width="120px" :model="editFinanceForm" :rules="editFinanceFormRule" ref="editFinanceForm">
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称" prop="customer_id">
                  <el-select size="small" v-model="editFinanceForm.customer_id" placeholder="请选择客户" filterable clearable style="width: 285px;" @change="handleCustomerChange()">
                    <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="项目编号" prop="apply_number">
                  <el-input size="small" v-model.trim="editFinanceForm.apply_number" auto-complete="off" placeholder="项目编号(专利号、软著号等)" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目名称" prop="apply_item">
                  <el-input size="small" v-model.trim="editFinanceForm.apply_item" auto-complete="off" placeholder="项目名称(专利名称、软件名称等)" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目时间" prop="event_time">
                  <el-date-picker
                    v-model="editFinanceForm.event_time"
                    type="date"
                    value-format="yyyy.MM.dd"
                    placeholder="选择项目日期"
                    align="right"
                    :picker-options="pickerOptions" style="width: 285px;">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="项目备注" prop="desc">
                  <el-input size="small" v-model.trim="editFinanceForm.desc" auto-complete="off" placeholder="备注" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收入金额" prop="income">
                  <el-input size="small" v-model.trim="editFinanceForm.income" auto-complete="off" placeholder="收入金额" @change="moneyChangeEdit()" clearable></el-input>
                </el-form-item>
                <el-form-item label="支出金额" prop="expense">
                  <el-input size="small" v-model.trim="editFinanceForm.expense" auto-complete="off" placeholder="支出金额" @change="moneyChangeEdit()" clearable></el-input>
                </el-form-item>
                <el-form-item label="付款单位" prop="payer">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.payer" auto-complete="off" placeholder="付款单位" clearable></el-input> -->
                   <el-select v-model="editFinanceForm.payer" placeholder="请选择或填写" filterable allow-create clearable style="width: 285px;">
                      <el-option v-for="item in companys" :key="item.value" :label="item.key" :value="item.value"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="收款单位" prop="payee">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.payee" auto-complete="off" placeholder="收款单位" clearable></el-input> -->
                  <el-select v-model="editFinanceForm.payee" placeholder="请选择或填写" filterable allow-create clearable style="width: 285px;">
                      <el-option v-for="item in companys" :key="item.value" :label="item.key" :value="item.value"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="账户余额" prop="balance">
                  <el-input size="small" v-model.trim="editFinanceForm.balance" auto-complete="off" placeholder="账户余额" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button v-no-more-click size="mini" type="primary" @click="commitEditFinance('editFinanceForm')">提交</el-button>
              <el-button size="mini" @click='closeEditFinanceDialog()'>取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 客户流水列表 -->
        <el-dialog v-dialogDrag :title="infoTitle" :close-on-click-modal="false" :visible.sync="financeVisible" width="1300px">
          <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
            <div class="mouse selected">财务流水</div>
          </div>
          <div style="float: right;display: flex;">
            <el-form :inline="true" :model="infoFinanceForm">
              <el-form-item label="时间" class="clueDatePicker" style="width: 300px;margin-top: -4px;">
                    <el-date-picker
                        v-model="searchDateValue"
                        @change="getSearchDate"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        unlink-panels
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00',  '23:59:59']"
                        style="width: 250px;">
                    </el-date-picker>
              </el-form-item>
              <el-input size="small" v-model.trim="infoFinanceForm.search" placeholder="请输入关键词" clearable style="width: 180px;"></el-input>
              <el-button v-no-more-click size="small" icon="el-icon-search" class="clue-btn" @click="searchInfoFinance" style="margin-left: 20px;">查询</el-button>
              <el-button v-if="addFinanceAuth" size="small" class="clue-btn" title="将选中记录向上移动" @click="moveUp">上移动</el-button>
              <el-button v-if="addFinanceAuth" size="small" class="clue-btn" title="将选中记录向下移动" @click="moveDown">下移动</el-button>
              <el-button v-if="addFinanceAuth" size="small" icon="el-icon-plus" class="clue-btn" @click="handleInfoAddFinance">新增流水</el-button>
              <el-button v-if="importFinanceAuth" size="small" icon="el-icon-top" class="clue-btn" @click="handleExportFinanceInfo">流水导入</el-button>
              <el-button v-if="importFinanceAuth" size="small" icon="el-icon-top" class="clue-btn" @click="exportFinanceExcel" title="根据筛选条件导出">流水导出</el-button>
              <el-button v-if="addFinanceAuth" size="small" icon="el-icon-delete" class="clue-btn" @click="checkDelFinance" title="删除勾选的数据记录">删除</el-button>
            </el-form>
          </div>
          <el-table size="small" :data="financeData" v-loading="financeLoading" border element-loading-text="拼命加载中" height="430" ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%;" tooltip-effect="dark">
                <el-table-column align="center" type="selection" width="40">
                </el-table-column>
                <el-table-column fixed prop="event_time" align="center" label="时间" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span style="color: #407AA8;cursor: pointer;" title="修改流水" @click="changeFinance(scope.$index, scope.row)">{{ scope.row.event_time }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="apply_number" align="center" label="项目编号" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="apply_item" align="center" label="项目名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="income" align="center" label="收入金额" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="addFinanceAuth" class="show-cursor" title="添加标记" @click="handleMark(scope.$index,scope.row,'income')"
                    :style="{backgroundColor: scope.row.style_json && scope.row.style_json.income ? scope.row.style_json.income : 'transparent'}">
                      <span>{{ scope.row.income }}</span>
                    </div>
                    <div v-else class="show-cursor"
                    :style="{backgroundColor: scope.row.style_json && scope.row.style_json.income ? scope.row.style_json.income : 'transparent'}">
                      <span>{{ scope.row.income }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="expense" align="center" label="支出金额" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="addFinanceAuth" class="show-cursor" title="添加标记" @click="handleMark(scope.$index,scope.row,'expense')"
                    :style="{backgroundColor: scope.row.style_json && scope.row.style_json.expense ? scope.row.style_json.expense : 'transparent'}">
                      <span>{{ scope.row.expense }}</span>
                    </div>
                    <div v-else class="show-cursor"
                    :style="{backgroundColor: scope.row.style_json && scope.row.style_json.expense ? scope.row.style_json.expense : 'transparent'}">
                      <span>{{ scope.row.expense }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="payer" align="center" label="付款单位" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="payee" align="center" label="收款单位" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="balance" align="center" label="余额" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="addFinanceAuth" class="show-cursor" title="添加标记" @click="handleMark(scope.$index,scope.row,'balance')"
                    :style="{backgroundColor: scope.row.style_json && scope.row.style_json.balance ? scope.row.style_json.balance : 'transparent'}">
                      <span>{{ scope.row.balance }}</span>
                    </div>
                    <div v-else class="show-cursor"
                    :style="{backgroundColor: scope.row.style_json && scope.row.style_json.balance ? scope.row.style_json.balance : 'transparent'}">
                      <span>{{ scope.row.balance }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="desc" align="center" label="备注" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" width="90" label="操作">
                  <template slot-scope="scope">
                    <el-button v-no-more-click size="mini" type="primary" title="在下方添加新记录" @click="handleInfoInsertFinance(scope.$index, scope.row)">添加</el-button>
                  </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 流水导入模版预览 -->
        <el-dialog v-dialogDrag title="模板预览" :close-on-click-modal="false" :visible.sync="financeExcelImgVisible" width="1200px">
          <el-image :src="financeExcelImgUrl" style="width: 100%;"></el-image>
        </el-dialog>

         <!-- 插入流水 -->
         <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="insertFormVisible" width="850px">
          <el-form label-width="120px" :model="insertFinanceForm" :rules="insertFinanceFormRule" ref="insertFinanceForm">
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称" prop="customer_id">
                  <el-select size="small" v-model="insertFinanceForm.customer_id" placeholder="请选择客户" filterable clearable style="width: 285px;" @change="handleCustomerChange()">
                    <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="项目编号" prop="apply_number">
                  <el-input size="small" v-model.trim="insertFinanceForm.apply_number" auto-complete="off" placeholder="项目编号(专利号、软著号等)" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目名称" prop="apply_item">
                  <el-input size="small" v-model.trim="insertFinanceForm.apply_item" auto-complete="off" placeholder="项目名称(专利名称、软件名称等)" clearable></el-input>
                </el-form-item>
                <el-form-item label="项目时间" prop="event_time">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.event_time" auto-complete="off" placeholder="格式:2025.09.04" clearable></el-input> -->
                  <el-date-picker
                    v-model="insertFinanceForm.event_time"
                    type="date"
                    value-format="yyyy.MM.dd"
                    placeholder="选择项目日期"
                    align="right"
                    :picker-options="pickerOptions" style="width: 285px;">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="项目备注" prop="desc">
                  <el-input size="small" v-model.trim="insertFinanceForm.desc" auto-complete="off" placeholder="备注" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收入金额" prop="income">
                  <el-input size="small" v-model.trim="insertFinanceForm.income" auto-complete="off" placeholder="收入金额" @change="moneyChangeInsert()" clearable></el-input>
                </el-form-item>
                <el-form-item label="支出金额" prop="expense">
                  <el-input size="small" v-model.trim="insertFinanceForm.expense" auto-complete="off" placeholder="支出金额" @change="moneyChangeInsert()" clearable></el-input>
                </el-form-item>
                <el-form-item label="付款单位" prop="payer">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.payer" auto-complete="off" placeholder="付款单位" clearable></el-input> -->
                   <el-select v-model="insertFinanceForm.payer" placeholder="请选择或填写" filterable allow-create clearable style="width: 285px;">
                      <el-option v-for="item in companys" :key="item.value" :label="item.key" :value="item.value"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="收款单位" prop="payee">
                  <!-- <el-input size="small" v-model.trim="addFinanceForm.payee" auto-complete="off" placeholder="收款单位" clearable></el-input> -->
                  <el-select v-model="insertFinanceForm.payee" placeholder="请选择或填写" filterable allow-create clearable style="width: 285px;">
                      <el-option v-for="item in companys" :key="item.value" :label="item.key" :value="item.value"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="账户余额" prop="balance">
                  <el-input size="small" v-model.trim="insertFinanceForm.balance" auto-complete="off" placeholder="账户余额" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button v-no-more-click size="mini" type="primary" @click="insertFinance('insertFinanceForm')">提交</el-button>
              <el-button size="mini" @click='closeInsertFinanceDialog()'>取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 背景色标记弹窗 -->
        <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="markFormVisible" width="450px">
          <div style="display: flex;">
            <div class="base-color" style="background-color: #ff9900;" @click="chooseColor('#ff9900')">
              <span v-if="chooseMarkColor == '#ff9900'">已选中</span>
            </div>
            <div class="base-color" style="background-color: #ffff00;" @click="chooseColor('#ffff00')">
              <span v-if="chooseMarkColor == '#ffff00'">已选中</span>
            </div>
            <div class="base-color" style="background-color: #92d050;" @click="chooseColor('#92d050')">
              <span v-if="chooseMarkColor == '#92d050'">已选中</span>
            </div>
            <div class="base-color" style="background-color: #f01515;" @click="chooseColor('#f01515')">
              <span v-if="chooseMarkColor == '#f01515'">已选中</span>
            </div>
            <div class="base-color" style="background-color: #21bef1;" @click="chooseColor('#21bef1')">
              <span v-if="chooseMarkColor == '#21bef1'">已选中</span>
            </div>
          </div>
          <div style="margin-top: 30px;">
            <el-button v-no-more-click size="mini" type="primary" @click="saveMarkForm()">保存</el-button>
            <el-button size="mini" @click='closeMarkDialog()'>取消</el-button>
          </div>
        </el-dialog>

        <!-- 右侧筛选框 -->
        <div>
          <div class="rightDrawer" @click="handleDrawerOpen">
            《《
          </div>
          <el-drawer 
          :visible.sync="drawer" 
          :direction="direction" 
          :before-close="handleDrawerClose" 
          size="360px" 
          title="条件查询" 
          :show-close="false"
          :wrapperClosable="true"
          class="searchDrawer" 
          >
            <div style="margin-left: 20px;">
                <el-form :inline="true" :model="formInline">
                  <el-form-item label="客户名称" style="width: 320px;">
                    <el-input size="small" v-model.trim="formInline.customer_name" placeholder="请输入客户名称" clearable style="width: 250px;"></el-input>
                  </el-form-item>
                  <el-form-item label="联系方式" style="width: 320px;">
                    <el-input size="small" v-model.trim="formInline.mobile" placeholder="请输入联系方式" clearable style="width: 250px;"></el-input>
                  </el-form-item>
                  <el-form-item label="跟进商务" v-if="addFinanceAuth" style="width: 320px;">
                    <el-select size="small" v-model.trim="formInline.admin_id" placeholder="请选择" filterable clearable style="width: 250px;">
                        <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="流水时间" class="clueDatePicker" style="width: 320px;">
                    <el-date-picker
                        v-model="searchDateValue"
                        @change="getSearchDate"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        unlink-panels
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00',  '23:59:59']"
                        style="width: 250px;">
                      </el-date-picker>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button type="primary" size="small" @click="searchFinance">查询</el-button>
                    <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
                    <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
                  </el-form-item>
                </el-form>
            </div>
          </el-drawer>
        </div>

        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>
<script>
import { 
  webUrl,
  getFinancePageList,
  getAuthAdmin,
  getAuthCustomer,
  editFinance,
  delFinance,
  getFinanceCustomerList,
  getCustomerFinance,
  getFinanceCustomerBalance,
  getPayeePayer,
  exportFinance,
  changeFinance,
  moveFinance,
  insertFinance,
  editFinanceMark,
  moveUpFinance,
  moveDownFinance
} from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
        loading: false, //是显示加载
        financeLoading: false, //是否显示加载
        financeExcelImgVisible: false,
        totalFee: 0,
        customerData: [], //客户数据
        financeData: [], //流水数据
        formInline: {
          page: 1,
          ps: 15,
          customer_name: '',
          admin_id: '',
          mobile: '',
          startDate: '',
          endDate: ''
        },
        addFinanceForm: {
          customer_name: '',
          customer_id: '',
          apply_item: '',
          apply_number: '',
          income: '',
          expense: '',
          payer: '',
          payee: '',
          balance: '',
          desc: '',
          event_time: ''
        },
        insertFinanceForm: {
          finance_id: '',
          customer_name: '',
          customer_id: '',
          apply_item: '',
          apply_number: '',
          income: '',
          expense: '',
          payer: '',
          payee: '',
          balance: '',
          desc: '',
          event_time: ''
        },
        editFinanceForm: {
          id: '',
          customer_name: '',
          customer_id: '',
          apply_item: '',
          apply_number: '',
          income: '',
          expense: '',
          payer: '',
          payee: '',
          balance: '',
          desc: '',
          event_time: ''
        },
        importFinanceForm: {
          customer_id: '',
          customer_name: ''
        },
        infoFinanceForm: {
          customer_id: '',
          startDate: '',
          endDate: '',
          search: ''
        },
        financeEditForm: {
          income: 0,
          expense: 0,
          balance: 0
        },
        chooseMarkColor: '',
        insertBalance: 0,
        editBalance: 0,
        title: '',
        infoTitle: '',
        exportFormVisible: false,
        addFormVisible: false,
        insertFormVisible: false,
        editFormVisible: false,
        financeVisible: false,
        markFormVisible: false,
        multipleSelection: [],
        multipleSelectionFinance: [],

        financeExcelImgUrl: '',
        // 权限开始
        addFinanceAuth: false,
        importFinanceAuth: false,
        // 权限结束

        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },

        markForm: {
          finance_id: '',
          field: '',
          bg_color: '',
          style_json: []
        },

        // 搜索框开始
        drawer: false,
        direction: 'rtl',
        searchDateValue: '',
        // 搜索框结束

        // 商务列表(查询)
        searchSeller: [],
        // 客户列表(查询)
        searchCustomer: [],
        companys: [],
        setHeader:{
          'token': localStorage.getItem('logintoken')
        },
        uploadExcel:webUrl + 'admin/finance/importFinance',

        // 参数校验
        addFinanceFormRule: {
          customer_name:[{ required: true, message: '请选择客户', trigger: 'blur' }],
          customer_id:[{ required: true, message: '请选择客户', trigger: 'blur' }],
          // apply_item:[{ required: true, message: '请输入项目名称', trigger: 'blur' }],
          event_time:[{ required: true, message: '请输入项目时间', trigger: 'blur' }]
        },
        // 参数校验
        insertFinanceFormRule: {
          finance_id:[{ required: true, message: '记录id不能为空', trigger: 'blur' }],
          customer_name:[{ required: true, message: '请选择客户', trigger: 'blur' }],
          customer_id:[{ required: true, message: '请选择客户', trigger: 'blur' }],
          // apply_item:[{ required: true, message: '请输入项目名称', trigger: 'blur' }],
          event_time:[{ required: true, message: '请输入项目时间', trigger: 'blur' }]
        },
        editFinanceFormRule: {
          customer_name:[{ required: true, message: '请选择客户', trigger: 'blur' }],
          customer_id:[{ required: true, message: '请选择客户', trigger: 'blur' }],
          // apply_item:[{ required: true, message: '请输入项目名称', trigger: 'blur' }],
          event_time:[{ required: true, message: '请输入项目时间', trigger: 'blur' }]
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 15,
          total: 10
        }
    }
  },
  // 注册组件
  components: { 
    Pagination
  },
  /**
   * 创建完毕
   */
   created() {
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    if(btnAuth.includes("addFinanceAuth")){
      this.addFinanceAuth = true
    }
    if(btnAuth.includes("importFinanceAuth")){
      this.importFinanceAuth = true
    }
    this.getFinanceData()
    this.getSellerSelectData()
    this.getCustomerSelectData()
   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 开启搜索框
    handleDrawerOpen() {
      this.drawer = true
    },
    // 点击查询
    searchFinance(){
      this.getFinanceData()
    },
    // 查询客户流水
    searchInfoFinance(){
      this.getCustomerFinanceData()
    },
    // 刷新数据
    refreshData() {
      console.log('刷新数据!')
      this.getFinanceData()
    },
    // 重置检索条件
    resetSearch() {
      this.formInline.page = 1
      this.formInline.ps = 15
      this.formInline.customer_name = ''
      this.formInline.admin_id = ''
      this.formInline.mobile = ''
      this.formInline.startDate = ''
      this.formInline.endDate = ''
      this.searchDateValue = ''
      this.getFinanceData()
      this.getSellerSelectData()
    },
    // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },
    // 监听日期选择器值的变化
    getSearchDate() {
      let dateValue = this.searchDateValue
      if(dateValue){
        this.infoFinanceForm.startDate = dateValue[0]
        this.infoFinanceForm.endDate = dateValue[1]
      }else{
        this.infoFinanceForm.startDate = ''
        this.infoFinanceForm.endDate = ''
      }
    },
    // 查询客户流水数据
    getFinanceData(){
      this.loading = true
      getFinanceCustomerList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.customerData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    handleInsert(index,row){
      console.log(row)
    },
    // 查询商务列表(搜索栏下拉框)
    getSellerSelectData() {
      getAuthAdmin()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.searchSeller = res.data
        }
      })
    },
    // 查询客户列表(搜索栏下拉框)
    getCustomerSelectData() {
      getAuthCustomer()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          res.data.shift()
          this.searchCustomer = res.data
        }
      })
    },
    // 开启新增流水弹窗(客户详情)
    handleInfoAddFinance(index,row){
      // 查询收付款单位
      getPayeePayer()
      .then(res=>{
        if(res.code == 200){
          this.companys = res.data
            let customer_id = this.infoFinanceForm.customer_id
            // 查询账户余额
            getFinanceCustomerBalance({customer_id: customer_id})
            .then(res=>{
              if(res.code == 200){
                this.title = '新增流水'
                this.addFinanceForm.id = ''
                this.addFinanceForm.customer_name = this.infoFinanceForm.customer_name
                this.addFinanceForm.customer_id = this.infoFinanceForm.customer_id
                this.addFinanceForm.apply_item = ''
                this.addFinanceForm.apply_number = ''
                this.addFinanceForm.income = ''
                this.addFinanceForm.expense = ''
                this.addFinanceForm.payer = ''
                this.addFinanceForm.payee = ''
                this.addFinanceForm.balance = res.data.balance
                this.addFinanceForm.desc = ''
                this.addFinanceForm.event_time = ''
                this.addFormVisible = true
                this.financeEditForm.income = 0
                this.financeEditForm.expense = 0
                this.financeEditForm.balance = res.data.balance
              }
            })
          }
      })
      
    },
    // 开启插入流水弹窗(客户详情)
    handleInfoInsertFinance(index,row){
      // 查询收付款单位
      getPayeePayer()
          .then(res=>{
            if(res.code == 200){
                this.companys = res.data
                this.title = '插入流水'
                this.insertFinanceForm.finance_id = row.id
                this.insertFinanceForm.customer_name = this.infoFinanceForm.customer_name
                this.insertFinanceForm.customer_id = this.infoFinanceForm.customer_id
                this.insertFinanceForm.apply_item = ''
                this.insertFinanceForm.apply_number = ''
                this.insertFinanceForm.income = ''
                this.insertFinanceForm.expense = ''
                this.insertFinanceForm.payer = ''
                this.insertFinanceForm.payee = ''
                this.insertFinanceForm.balance = row.balance
                this.insertFinanceForm.desc = ''
                this.insertFinanceForm.event_time = ''
                this.insertFormVisible = true
                this.insertBalance = row.balance
            }
          })
    },
    // 开启修改流水弹窗(客户详情)
    changeFinance(index,row){
      // 查询收付款单位
      getPayeePayer()
      .then(res=>{
        if(res.code == 200){
            this.companys = res.data
            this.title = '修改流水'
            this.editFinanceForm.id = row.id
            this.editFinanceForm.customer_name = row.customer_name
            this.editFinanceForm.customer_id = row.customer_id
            this.editFinanceForm.apply_item = row.apply_item
            this.editFinanceForm.apply_number = row.apply_number
            this.editFinanceForm.income = row.income
            this.editFinanceForm.expense = row.expense
            this.editFinanceForm.payer = row.payer
            this.editFinanceForm.payee = row.payee
            this.editFinanceForm.balance = row.balance
            this.editFinanceForm.desc = row.desc
            this.editFinanceForm.event_time = row.event_time
            
            // 获取上一次节点的余额数据
            let financeData = this.financeData
            let lastI = 0
            financeData.forEach((item,index)=>{
              if(item.id == row.id){
                if(index != financeData.length -1){
                  lastI = index - 1
                }
              }
            })
            this.editFormVisible = true
            this.editBalance = financeData[lastI].balance
            console.log(this.editFinanceForm)
            console.log(this.editBalance)
          }
      })
    },
    // 查看客户流水详情
    getFinanceList(index,row){
      let name = row.customer_name
      this.infoTitle = name +''
      this.infoFinanceForm.customer_id = row.id
      this.infoFinanceForm.customer_name = row.customer_name
      this.infoFinanceForm.startDate = ''
      this.infoFinanceForm.endDate = ''
      this.infoFinanceForm.search = ''
      this.getCustomerFinanceData()
      this.financeVisible = true
    },
    getCustomerFinanceData(){
      this.financeLoading = true
      getCustomerFinance(this.infoFinanceForm)
      .then(res=>{
        this.financeLoading = false
        res = checkLogin(res);
        if(res.code == 200){
          this.financeData = res.data
        }else{
          this.financeData = []
        }
      })
    },
    // 导出客户流水
    exportFinanceExcel(){
      this.$confirm('确定导出所有满足条件的流水记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        // 查询并导出
        exportFinance(this.infoFinanceForm)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '导出成功!'
            }) 
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
          }
        })
      })
      // .catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消'
      //   })
      // })
    },
    // 关闭新增流水弹窗
    closeAddFinanceDialog(){
      this.addFormVisible = false
    },
     // 关闭插入流水弹窗
     closeInsertFinanceDialog(){
      this.insertFormVisible = false
    },
    // 关闭修改流水弹窗
    closeEditFinanceDialog(){
      this.editFormVisible = false
    },

    // 添加流水提交
    addFinance(addFinanceForm){
      this.$refs[addFinanceForm].validate(valid => {
        if(valid){
          editFinance(this.addFinanceForm)
          .then(res=>{
            if(res.code==200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getCustomerFinanceData()
              this.addFormVisible = false
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

        }else{
          return false
        }
      })
    },
    // 插入流水提交
    insertFinance(insertFinanceForm){
      this.$refs[insertFinanceForm].validate(valid => {
        if(valid){
          insertFinance(this.insertFinanceForm)
          .then(res=>{
            if(res.code==200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getCustomerFinanceData()
              this.insertFormVisible = false
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

        }else{
          return false
        }
      })
    },
    // 关闭选择标记颜色弹窗
    closeMarkDialog(){
      this.markFormVisible = false
    },
    // 开启添加标记弹窗
    handleMark(index,row,field){
      this.markFormVisible = true
      this.chooseMarkColor = ''
      this.markForm.field = field
      this.markForm.bg_color = ''
      this.markForm.finance_id = row.id
      this.markForm.style_json = row.style_json||''
      let style_json = row.style_json
      if(style_json && style_json != null){
        if(style_json[field]){
          this.chooseMarkColor = style_json[field]
          this.markForm.bg_color = style_json[field]
        }else{
          this.chooseMarkColor = ''
          this.markForm.bg_color = ''
        }
      }
      this.title = '选择标记颜色'
      console.log(this.markForm)
    },
    // 选择标记颜色
    chooseColor(color){
      if(this.chooseMarkColor == color){
        this.chooseMarkColor = ''
        this.markForm.bg_color = ''
      }else{
        this.chooseMarkColor = color
        this.markForm.bg_color = color
      }
      console.log('勾选数据')
      console.log(this.markForm)
    },
    // 保存颜色标记
    saveMarkForm(){
      console.log(this.markForm)
      let field = this.markForm.field
      let bg_color = this.markForm.bg_color
      let style = this.markForm.style_json || {}
      if(field && bg_color){
        style[field] = bg_color
      }else{
        delete style[field]
      }
      let param = {
        finance_id: this.markForm.finance_id,
        style_json: JSON.stringify(style)
      }
      console.log(param)
      editFinanceMark(param)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.markFormVisible = false
          this.getCustomerFinanceData()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 提交修改流水
    commitEditFinance(editFinanceForm){
      this.$refs[editFinanceForm].validate(valid => {
        if(valid){
          changeFinance(this.editFinanceForm)
          .then(res=>{
            if(res.code==200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getCustomerFinanceData()
              this.editFormVisible = false
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

        }else{
          return false
        }
      })
    },
    // 处理客户值发生改变
    handleCustomerChange(){
      let customer_id = this.addFinanceForm.customer_id
      if(customer_id){
        let customerData = this.searchCustomer
        customerData.forEach((item,index)=>{
          if(item.value == customer_id){
            this.addFinanceForm.customer_name = item.key
          }
        })
      }
    },
    handleImportCustomerChange(){
      let customer_id = this.importFinanceForm.customer_id
      if(customer_id){
        let customerData = this.searchCustomer
        customerData.forEach((item,index)=>{
          if(item.value == customer_id){
            this.importFinanceForm.customer_name = item.key
          }
        })
      }
    },

    // 显示流水导入弹窗 
    handleExportFinanceInfo(){
      this.title = '流水导入'
      this.importFinanceForm.customer_id = this.infoFinanceForm.customer_id
      this.importFinanceForm.customer_name = this.infoFinanceForm.customer_name
      this.exportFormVisible = true
    },

    // 查看流水导入模板
    viewFinanceMB(){
      let url = 'https://crmapi.qzhip.com/template/finance_excel_mb.png'
      this.financeExcelImgUrl = url
      this.financeExcelImgVisible = true
    },
    
    // 删除勾选中的流水数据 
    checkDelFinance(){
      let checks = this.multipleSelection;
      if(checks.length <= 0 || checks.length > 1){
        this.$message({
          type: 'warning',
          message: '未勾选记录或勾选记录大于1'
        })
        return false
      }
      this.$confirm('确定删除勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let idArr = []
        checks.forEach(function(item,index){
          idArr.push(item.id)
        })
        let ids = JSON.stringify(idArr)
        delFinance({ids: ids})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCustomerFinanceData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },

    // 移动勾选中的流水数据
    moveTop(){
      let checks = this.multipleSelection;
      if(checks.length <= 0 || checks.length > 1){
        this.$message({
          type: 'warning',
          message: '未勾选记录或勾选记录大于1'
        })
        return false
      }
      this.$confirm('确定移动勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let param = {
          id: checks[0].id,
          customer_id: checks[0].customer_id,
          expense: checks[0].expense,
          income: checks[0].income
        }
        moveFinance(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCustomerFinanceData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 上移动勾选中的流水记录
    moveUp(){
      let checks = this.multipleSelection;
      if(checks.length <= 0 || checks.length > 1){
        this.$message({
          type: 'warning',
          message: '未勾选记录或勾选记录大于1'
        })
        return false
      }
      this.$confirm('确定上移勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let param = {id: checks[0].id}
        moveUpFinance(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCustomerFinanceData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    // 下移动选中的流水记录
    moveDown(){
      let checks = this.multipleSelection;
      if(checks.length <= 0 || checks.length > 1){
        this.$message({
          type: 'warning',
          message: '未勾选记录或勾选记录大于1'
        })
        return false
      }
      this.$confirm('确定下移勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let param = {id: checks[0].id}
        moveDownFinance(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCustomerFinanceData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },

    // 收入(支出)金额发生改变
    moneyChange(){
      let income = this.addFinanceForm.income
      let expense = this.addFinanceForm.expense
      let old_balance = this.financeEditForm.balance
      this.addFinanceForm.balance = Number(old_balance) + Number(income) - Number(expense)
      // if(income && expense){
      //   this.addFinanceForm.balance = Number(old_balance) + Number(income) - Number(expense)
      // }else if(income && !expense){
      //   this.addFinanceForm.balance = Number(old_balance) + Number(income)
      // }else if(!income && expense){
      //   this.addFinanceForm.balance = Number(old_balance) - Number(expense)
      // }else{
      //   this.addFinanceForm.balance = Number(old_balance)
      // }
    },
    moneyChangeEdit(){
      let income = this.editFinanceForm.income
      let expense = this.editFinanceForm.expense
      // let old_balance = this.financeEditForm.balance
      let old_balance = this.editBalance
      this.editFinanceForm.balance = Number(old_balance) + Number(income) - Number(expense)
    },
    moneyChangeInsert(){
      let income = this.insertFinanceForm.income
      let expense = this.insertFinanceForm.expense
      let old_balance = this.insertBalance
      this.insertFinanceForm.balance = Number(old_balance) + Number(income) - Number(expense)
    },
    moneyEditChangeIncome(){
      let income = this.editFinanceForm.income
      let expense = this.editFinanceForm.expense
      let balance = this.editFinanceForm.balance
      let old_balance = this.financeEditForm.balance
      let old_income = this.financeEditForm.income
      let old_expense = this.financeEditForm.expense
      if(income && income != old_income && expense == old_expense){
        this.editFinanceForm.balance = Number(old_balance) - Number(old_income) + Number(income)
      }else if(!income){

      }
      // if(income && expense){
      //   this.editFinanceForm.balance = Number(old_balance) + Number(income) - Number(expense)
      // }else if(income && !expense){
      //   this.editFinanceForm.balance = Number(old_balance) + Number(income)
      // }else if(!income && expense){
      //   this.editFinanceForm.balance = Number(old_balance) - Number(expense)
      // }else{
      //   this.editFinanceForm.balance = Number(old_balance)
      // }
    },
    moneyEditChangeExpense(){

    },

    // 文件上传开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.exportFormVisible = false
          this.importFinanceForm.customer_id = ''
          this.importFinanceForm.customer_name = ''
          this.getCustomerFinanceData()
          this.getFinanceData()
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      if(!this.importFinanceForm.customer_id || !this.importFinanceForm.customer_name){
          this.$message({
                type: 'warning',
                message: '请先选择客户!'
          })
          return false
      }
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }
    }, 
    // 文件上传结束

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getFinanceData()
    },
  }
}
</script>
<style scoped>
.mouse {
  cursor: pointer;
  color: #D9D9D9;
  margin-right: 18px;
}
.selected {
  color: #333333;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
.clueDatePicker>>>.el-range-editor.el-input__inner {
  padding: 1px 4px;
}
.clueDatePicker>>>.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 215px;
  height: 34px;
}
.fee-content {
  height: 46px;
  line-height: 46px;
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  border: 1px solid #EBEEF5;
}
.fee-item {
  margin: 0px 20px;
}
.fee-title {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  margin-left: 10px;
}
.fee-v {
  font-size: 18px;
  color: #215ac9;
  font-weight: 700;
  margin-left: 10px;
}
.show-cursor {
  cursor: pointer;
}
.base-color {
  width: 56px;
  height: 28px;
  margin-right: 20px;
  border: 1px solid #909090;
  cursor: pointer;
  text-align: center;
  line-height: 28px;
}
</style>


// WEBPACK FOOTER //
// src/views/crm/finance.vue